import React, { useState, useEffect } from "react";
import "../styles/../../styles/practicePage/AlphabetSelector.css";

const AlphabetSelector = ({ onSelectionChange, reset, onResetCompleted, selectAll }) => {
  const [selectedItems, setSelectedItems] = useState([]);

  // Define character sets
  const alphabet = "ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("");
  const numbers = "0123456789".split("");
  const specialCharacters = [
    "‘",
    "“",
    ":",
    ";",
    ",",
    "/",
    "-",
    "(",
    ")",
    ".",
    "?",
    "=",
    "+",
    "@",
  ];

  // Function to toggle selection for any character
  const toggleSelection = (char) => {
    const updatedSelection = selectedItems.includes(char)
      ? selectedItems.filter((item) => item !== char) // Remove if already selected
      : [...selectedItems, char]; // Add if not selected

    setSelectedItems(updatedSelection);
    onSelectionChange(updatedSelection);
  };

  // Reset logic
  useEffect(() => {
    if (reset) {
      setSelectedItems([]);
      onSelectionChange([]);
      onResetCompleted();
    }
  }, [reset, onSelectionChange, onResetCompleted]);

  useEffect(() => {
    if (selectAll) {
      const allCharacters = [...alphabet, ...numbers, ...specialCharacters];
      setSelectedItems(allCharacters);
      onSelectionChange(allCharacters);
    }
  }, [selectAll, onSelectionChange]);

  return (
    <div className="selectLetters">
      <div className="lettersTitle">Select Characters</div>

      {/* Letters Section */}
      <div className="lettersSelector alphabet">
        {alphabet.map((letter) => (
          <button
            key={letter}
            className={`letter ${
              selectedItems.includes(letter) ? "selected" : ""
            }`}
            onClick={() => toggleSelection(letter)}
          >
            {letter}
          </button>
        ))}
      </div>

      {/* Numbers Section */}
      <div className="lettersSelector numbers pt-5">
        {numbers.map((number) => (
          <button
            key={number}
            className={`letter ${
              selectedItems.includes(number) ? "selected" : ""
            }`}
            onClick={() => toggleSelection(number)}
          >
            {number}
          </button>
        ))}
      </div>

      {/* Special Characters Section */}
      <div className="lettersSelector specialCharacters pt-5">
        {specialCharacters.map((char) => (
          <button
            key={char}
            className={`letter ${
              selectedItems.includes(char) ? "selected" : ""
            }`}
            onClick={() => toggleSelection(char)}
          >
            {char}
          </button>
        ))}
      </div>
    </div>
  );
};

export default AlphabetSelector;
